import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Hero = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: '50px',
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.5,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section className="pt-32 lg:pt-40 pb-12 overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          ref={ref}
          className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12"
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <div className="w-full lg:w-1/2 space-y-6">
            <motion.h1 
              variants={itemVariants}
              className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight"
            >
              Interrupt the ordinary. Like having TikTok on your website.
            </motion.h1>
            
            <motion.p 
              variants={itemVariants}
              className="text-lg md:text-xl text-gray-700 mb-4"
            >
              Easily add videos to your site with our <a href="/#why" className="text-purple-si hover:text-purple-si/90 underline">video overlay tool</a>. Ignite sales and signups. Lift engagement and conversions effortlessly.
            </motion.p>
            
            <motion.div 
              variants={itemVariants}
              className="flex flex-col sm:flex-row gap-4"
            >
              <a
                href="https://dashboard.salesintercept.com/signup"
                className="btn btn-primary text-center transition-transform hover:scale-105 active:scale-95"
              >
                Start Free Trial
              </a>
            </motion.div>
            
            <motion.p 
              variants={itemVariants}
              className="text-sm text-gray-500 italic"
            >
              One-time code embed. No technical skills or credit card required.
            </motion.p>
          </div>
          
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;